//////////////////////////////////////////////////////////////////////////////////////   IMPORT
///////////////////////////////////////////////////////////   REACT
import React from 'react';
///////////////////////////////////////////////////////////   SCSS
import './home-menu.styles.scss';
///////////////////////////////////////////////////////////   FONTAWESOME
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
///////////////////////////////////////////////////////////   INTERFACE
declare global {
  interface Window {
    darkmode: boolean | any;
  }
}
export interface PostProps {
  // _mergedGenConf: any;
}
//////////////////////////////////////////////////////////////////////////////////////    CLASS SETUP
export default class HomeMenu extends React.Component<PostProps, { [key: string]: any }> {
  constructor(props: PostProps) {
    super(props);
    this.state = {
      ...props
    };
  }
  ///////////////////////////////////////////////////////////   LIFECYCLE METHODS
  componentDidMount() { }
  ///////////////////////////////////////////////////////////   CLASS METHODS
  ///////////////////////////////////////////////////////////   RENDER
  render() {
    return (
      <div className='homeMenuList'>
        <ul>
          <li>
            <a href='/#/audio-player'>audio-player</a>
          </li>
          <li>
            <a href='/#/videojs-player'>videojs-player</a>
          </li>
        </ul>
      </div>
    );
  }
}
